import type {
  EquityOverview,
  MutualFundOverview,
} from '#/api/generated/fINRAMarketDataAPI.schemas';

interface PriceChangeDisplay {
  percentChange: number | null | undefined;
  valueChange: number | null | undefined;
  periodLabel: string;
}

type EquityPriceChangeOverview = Pick<
  EquityOverview,
  | 'price_change_5Y_percent'
  | 'price_change_5Y_dollar'
  | 'alt_price_change_percent'
  | 'alt_price_change_dollar'
  | 'alt_price_change_label'
>;

export function getEquityETFPriceChangeDisplay(
  overview: EquityPriceChangeOverview | null | undefined,
): PriceChangeDisplay {
  const has5YChange = overview?.price_change_5Y_percent != null;

  if (has5YChange) {
    return {
      percentChange: overview.price_change_5Y_percent,
      valueChange: overview.price_change_5Y_dollar,
      periodLabel: '5Y',
    };
  }

  return {
    percentChange: overview?.alt_price_change_percent,
    valueChange: overview?.alt_price_change_dollar,
    periodLabel: overview?.alt_price_change_label ?? '',
  };
}

type MutualFundPriceChangeOverview = Pick<
  MutualFundOverview,
  | 'price_change_1Y_percent'
  | 'price_change_1Y_dollar'
  | 'alt_price_change_percent'
  | 'alt_price_change_dollar'
  | 'alt_price_change_label'
>;

export function getMutualFundPriceChangeDisplay(
  overview: MutualFundPriceChangeOverview | null | undefined,
): PriceChangeDisplay {
  const has1YChange = overview?.price_change_1Y_percent != null;

  if (has1YChange) {
    return {
      percentChange: overview.price_change_1Y_percent,
      valueChange: overview.price_change_1Y_dollar,
      periodLabel: '1Y',
    };
  }

  return {
    percentChange: overview?.alt_price_change_percent,
    valueChange: overview?.alt_price_change_dollar,
    periodLabel: overview?.alt_price_change_label ?? '',
  };
}
